import Vue from 'vue'
import localStorage from 'vue-localstorage'
import store from '@/store'

Vue.use(localStorage)

export default {
  globalBeforeEachRouter (to, from, next) {
    if (to.name === 'login' || to.name === 'loginSpecificLanguage' || to.name === 'loginRMP') {
      next()
    } else {
      if (Vue.localStorage.get('token') === null) {
        next(false)
        window.location = process.env.LOGIN_URL
      } else {
        this.getAccount()
        this.getBusinessId()
        next()
      }
    }
  },
  getAccount () {
    if (store.state.accounts.webName === '') {
      store.dispatch('getAccount')
    }
  },
  getBusinessId () {
    store.dispatch('getBusinessId')
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware.js